<template>
  <div class="relative">
    <!-- try not to use both "submit" and "input" events at the same time -->
    <input
      ref="input"
      :value="value"
      type="text"
      :placeholder="placeholder"
      class="rounded-3xl pl-4 py-2 w-full input-styling"
      :class="{ 'pr-20': icon, 'py-4': large }"
      :autofocus="autofocus"
      @input="inputEvent"
      @keydown.enter="submit"
    />
    <AtomIcon v-if="icon" :icon="icon" classes="w-4 h-4 absolute input-icon text-app-primary-1-red--fire-brick cursor-pointer" :class="{ 'w-6 h-6': large }" @click="submit" />
  </div>
</template>

<script setup lang="ts">
import debounce from 'lodash/debounce'

defineProps({
  value: { type: String, required: false, default: '' },
  placeholder: { type: String, required: true },
  icon: { type: String, required: false, default: null },
  large: { type: Boolean, required: false, default: false },
  autofocus: { type: Boolean, required: false, default: false },
})

const emit = defineEmits(['input', 'submit'])

const input = ref<HTMLInputElement | undefined>(undefined)

const focus = () => unref(input)?.focus()

const inputEvent = debounce(() => {
  // use debounce to delay the search term feedback
  // this should prevent the value being send in "fragments", which is handy if used as query params
  // be wary that debounce could also be used in other places like the store
  emit('input', input.value?.value)
}, 500)

const submit = () => emit('submit', input.value?.value)

defineExpose({ focus })
</script>

<style lang="scss" scoped>
.input-icon {
  top: 0;
  bottom: 0;
  margin: auto;
  right: 20px;
}

.input-styling {
  text-indent: 20px;
  caret-color: red;
  @apply font-normal;

  &::placeholder {
    @apply opacity-100 text-black italic;
  }
}
</style>
